module.exports = __webpack_public_path__ + "static/media/19.6112bfff.jpg";